export const unstable_batchedUpdates = null;
export const ColorValue = {};
export const ViewStyle = {};
export const TouchableHighlightProps = {};
export const StyleProp = {};
export const ViewProps = {};
export const TextStyle = {};
export const PressableProps = {};
export const useDidShow = () => {};
export const useDidHide = () => {};
export const lockToPortrait = () => {};
export const removeWakeUpListener = () => {};
export const init = () => {};
export const configWeixin = () => {};
export default {
  init,
  configWeixin,
  useDidHide: useDidHide,
  useDidShow: useDidShow,
  lockToPortrait,
  removeWakeUpListener
};



// WEBPACK FOOTER //
// ../biz-micro-services-ui/packages/empty/index.js